/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserReportStatus } from './UserReportStatus';
import {
    UserReportStatusFromJSON,
    UserReportStatusFromJSONTyped,
    UserReportStatusToJSON,
    UserReportStatusToJSONTyped,
} from './UserReportStatus';

/**
 * Schema for setting one status on several reports at once.
 * @export
 * @interface UserReportBulkStatusUpdate
 */
export interface UserReportBulkStatusUpdate {
    /**
     * Reports to update
     * @type {Array<string>}
     * @memberof UserReportBulkStatusUpdate
     */
    ids: Array<string>;
    /**
     * 
     * @type {UserReportStatus}
     * @memberof UserReportBulkStatusUpdate
     */
    status: UserReportStatus;
}



/**
 * Check if a given object implements the UserReportBulkStatusUpdate interface.
 */
export function instanceOfUserReportBulkStatusUpdate(value: object): value is UserReportBulkStatusUpdate {
    if (!('ids' in value) || value['ids'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function UserReportBulkStatusUpdateFromJSON(json: any): UserReportBulkStatusUpdate {
    return UserReportBulkStatusUpdateFromJSONTyped(json, false);
}

export function UserReportBulkStatusUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserReportBulkStatusUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'ids': json['ids'],
        'status': UserReportStatusFromJSON(json['status']),
    };
}

export function UserReportBulkStatusUpdateToJSON(json: any): UserReportBulkStatusUpdate {
    return UserReportBulkStatusUpdateToJSONTyped(json, false);
}

export function UserReportBulkStatusUpdateToJSONTyped(value?: UserReportBulkStatusUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ids': value['ids'],
        'status': UserReportStatusToJSON(value['status']),
    };
}

